import { FieldErrors, UseFormRegister } from "react-hook-form";
import { TmaisUserData } from "../types/tmaisUsers.type";
import { TmaisUsersValidationSchema } from "../schemas/update.schema";
import { Dispatch, SetStateAction } from "react";
import TmaisUserUpdateGeneralData from "../tabs/users/components/updateUser/GeneralData";
import TmaisUserGeneralData from "../tabs/users/components/showUser/GeneralData";

interface DefaultTabsProps {
  tmaisUser: TmaisUserData
  updatePage?: boolean
  register?: UseFormRegister<TmaisUsersValidationSchema>
  setFile?: Dispatch<SetStateAction<Blob | undefined>>
  file?: Blob | undefined
  errors?: FieldErrors<TmaisUsersValidationSchema>
}

export const defaultTabs = ({tmaisUser, updatePage, register, setFile, file, errors}: DefaultTabsProps) => {

  const returnGeneralData = ():JSX.Element | string => {
    if(updatePage && register && setFile) {
      return (
        <TmaisUserUpdateGeneralData
          tmaisUser={tmaisUser}
          register={register}
          setFile={setFile}
          file={file}
          errors={errors}
        />
      )
    }

    return <TmaisUserGeneralData tmaisUser={tmaisUser} />
  }

  return [
    {
      label: 'Dados Gerais',
      value: '',
      body: returnGeneralData()
    },
  ]
}
